import { CheckmarkFilledIcon, InfoFilledIcon } from '@calizahq/react-components-v2'
import { Link } from 'react-router-dom'

import { Tag } from '@/components'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'
import { HomesResponse } from '@/types/Homes'

export const HomesListColumns = [
  {
    Header: 'Home',
    accessor: 'name',
    width: 60,
    Cell: ({ row }: { row: { original: any } }) => {
      const { name, bedBath } = row.original

      return (
        <div className="flex items-center justify-center" style={{ overflowWrap: 'break-word' }}>
          <div className="flex flex-col font-medium">
            <h3 className="font-bold">{name}</h3>
            <p className="text-sm text-tertiary">Floorplan: {bedBath}</p>
          </div>
        </div>
      )
    },
  },
  {
    Header: 'Next Available',
    accessor: 'nextAvailableDate',
    width: 30,
  },
  {
    Header: 'Installed',
    accessor: 'installed',
    Cell: ({ value }: any) => {
      return value && <CheckmarkFilledIcon className="mr-3 text-green-300" height={24} width={24} />
    },
    width: 20,
  },
  {
    Header: 'Published',
    accessor: 'published',
    Cell: ({ value }: any) => {
      return value && <CheckmarkFilledIcon className="mr-3 text-green-300" height={24} width={24} />
    },
    width: 20,
  },
  {
    Header: 'Status',
    accessor: 'homeQualityStatus',
    Cell: ({ value }: any) => {
      return (
        <Tag className="ml-2" variant={value === HomeQualityCheckStatus.READY ? 'success' : 'error'}>
          {value}
        </Tag>
      )
    },
    width: 20,
  },
  {
    Header: 'Blocked',
    accessor: 'blocked',
    Cell: ({ value }: any) => {
      return value && <CheckmarkFilledIcon className="mr-3 text-red-300" height={24} width={24} />
    },
    width: 20,
  },
  {
    accessor: 'id',
    width: 10,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="ml-auto flex items-center justify-center" title="View Home">
          <Link to={`/homes/${value}`}>
            <InfoFilledIcon className="ml-2 text-green-300" height={24} width={24} />
          </Link>
        </div>
      )
    },
  },
]

export function homesMapper(homes: HomesResponse[]) {
  return homes.map((home) => ({
    id: home.id,
    homeQualityStatus: home.homeQualityStatus,
    name: home.searchDocument,
    bedBath: home.bedrooms + '/' + home.baths,
    nextAvailableDate:
      home.earliestAvailableDate != null ? new Date(home.earliestAvailableDate + 'Z').toLocaleDateString() : null,
    installed: !!home.installed,
    published: !!home.published,
    blocked: !!home.blocked,
  }))
}
